import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IStepCheckbox } from '../../interfaces/step-checkbox.interface';

@Component({
  standalone: false,
  selector: 'app-step-multiple-choice',
  templateUrl: './multiple-choice.component.html',
  styleUrls: ['./multiple-choice.component.scss'],
})
export class MultipleChoiceComponent implements OnInit {
  @Input() protected parentFormGroup: FormGroup;
  @Input() readonly formGroup: FormGroup;
  @Input() protected controlName: string;

  @Input() checkboxes: IStepCheckbox[];

  /** A StepCheckbox for the "None of the above" option, or omit disable this checkbox. */
  @Input() public none: IStepCheckbox | undefined;

  ngOnInit() {
    if (this.none) {
      this.formGroup.addControl(this.none.name, this.none.formControl || new FormControl(false));
    }
    for (const checkbox of this.checkboxes) {
      this.formGroup.addControl(checkbox.name, checkbox.formControl || new FormControl(false));
    }
  }

  onToggle(controlName: string) {
    const control = this.formGroup.controls[controlName];

    if (!control) {
      return;
    }

    if (this.none && control.value) {
      if (controlName === this.none.name) {
        for (const [name, groupControl] of Object.entries(this.formGroup.controls)) {
          groupControl.setValue(name === this.none.name, { emitEvent: false });
        }
      } else {
        this.formGroup.controls[this.none.name].setValue(false, { emitEvent: false });
      }
    }
  }
}
